/**
 *
 * InternalError
 *
 */

import { Helmet } from 'react-helmet-async';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import TripshockCardInfo from '@ts/components/TripshockCardInfo';
import { webPCheck } from '@ts/utils/useWebPCheckSupport';
import * as S from '@ts/components/TripshockCardInfo/styles';

import backgroundImage from '@ts/images/505-bg.png';
import backgroundImageWebP from '@ts/images/505-bg.webp';

/* eslint-disable react/prefer-stateless-function */
export class InternalError extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            seconds: 30,
        };

        this.interval = undefined;
        this.WebP = true;
    }

    componentDidMount() {
        this.interval = setInterval(
            () =>
                this.setState(
                    (prevState) => ({
                        seconds: prevState.seconds - 1,
                    }),
                    () => {
                        if (this.state.seconds < 0) {
                            this.props.history.push('/');
                        }
                    }
                ),
            1000
        );

        this.WebP = async () => await webPCheck();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <S.Section
                data-test-id="internal-error"
                backgroundImage={this.WebP ? backgroundImageWebP : backgroundImage}
            >
                <Helmet>
                    <title>TripShock - Server Error</title>
                </Helmet>
                <TripshockCardInfo textAlign="center">
                    <S.Title data-test-id="title">500 - Server Error</S.Title>
                    <S.Text data-test-id="description">
                        Looks like you broke the Internet. Just kidding…
                    </S.Text>
                    <S.Button data-test-id="button" as={Link} to="/">
                        SENDING YOU HOME IN&nbsp;
                        {this.state.seconds}
                    </S.Button>
                    <S.Text data-test-id="friendly-text">
                        We will get this fixed ASAP. The team has already been notified. Thanks for
                        your patience.
                    </S.Text>
                </TripshockCardInfo>
            </S.Section>
        );
    }
}

InternalError.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default withRouter(InternalError);
